import { deselectOrderId, setBookingApplicationMod } from 'entities/orders/model/ordersSlice';
import { Order } from 'entities/orders/model/types';
import { FC } from 'react';
import { useModal } from 'shared/lib/modal';
import { useAppDispatch } from 'shared/lib/store';
import { PenIconButton } from 'shared/ui/buttons/iconButtons/penButton';
import { EditContainer } from './styles';
import { useOrderInfo } from 'entities/orders/lib/hooks/order/useOrderInfo';
import { getOrder } from 'entities/orders/model/ordersThunk';
import { useOrderState } from 'entities/orders/lib/hooks/order/useOrderState';

export const OrderEdit: FC<{ order: Order, selectOrder?: ((id: number) => Promise<void>) }> = ({ order, selectOrder }) => {
	const dispatch = useAppDispatch();
	const { openModal } = useModal();
	const { open } = useOrderInfo();
	const { isVisitEnd } = useOrderState(order);

	const editBooking = async (event?: React.SyntheticEvent) => {
		event?.stopPropagation();

		if (order) {
      dispatch(deselectOrderId());
      await selectOrder?.(order?.id);
      setTimeout(async () => {
        await dispatch(getOrder({ id: order?.id }));
  
        if (!order.appointment) {
          await dispatch(setBookingApplicationMod({ isWork: true }));
        } else {
          await dispatch(setBookingApplicationMod({ isWork: false }));
        }
  
        open();
        openModal();
      }, 500);
		}
	};

	return (
		<EditContainer className="edit-order" style={{ minWidth: '40px' }}>
			{!isVisitEnd && (
				<PenIconButton
					onClick={editBooking}
				/>
			)}
		</EditContainer>
	);
};
